import React from "react";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

//Customize components for react markdown
const components = {
  p: ({ node, ...props }) => <p className="mb-0" {...props} />,
};

const ReactMarkdownComponent = ({ message }) => {
  return (
    <Markdown
      components={components}
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
    >{`${message}`}</Markdown>
  );
};

export default ReactMarkdownComponent;
